import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { FBA_PREP_CONTACT_PATH } from './fbaPrepCta';
import './FbaPrepPricingCta.css';

type FbaPrepPricingCtaProps = {
  label?: string;
  title?: string;
  subtitle?: ReactNode;
  variant?: 'blue' | 'orange';
};

export default function FbaPrepPricingCta({
  label = 'Free quote',
  title = 'Get a custom FBA prep quote',
  subtitle = 'Share your volume, product types and inbound plan — we respond within one business day.',
  variant = 'blue',
}: FbaPrepPricingCtaProps) {
  return (
    <aside
      className={`fba-prep-cta-strip fba-prep-cta-strip--${variant}`}
      aria-label="Request a custom FBA prep quote"
    >
      <div className="fba-prep-cta-strip-inner">
        <div className="fba-prep-cta-strip-text">
          <p className="fba-prep-cta-strip-label">{label}</p>
          <p className="fba-prep-cta-strip-title">{title}</p>
          <p className="fba-prep-cta-strip-sub">{subtitle}</p>
        </div>
        <Link to={FBA_PREP_CONTACT_PATH} className="fba-prep-cta-strip-btn">
          Get custom quote →
        </Link>
      </div>
    </aside>
  );
}
